import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'atw-popup-hover-blank-admin',
  templateUrl: './popup-hover-blank-admin.component.html',
  styleUrls: ['./popup-hover-blank-admin.component.scss']
})
export class PopupHoverBlankAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
